import { Button } from '@cluey/cluey-components';
import { Link } from 'react-router-dom';

import { PATH_HUB_HOME } from '../../util/pagePath';

const PageNotFound = () => {
  return (
    <div className="brand-cta flex h-[100%] flex-col items-center justify-center">
      <h1 className="line-height-[100px] font-display text-[120px] font-bold text-grey-3">404</h1>
      <h2 className="line-height-[48px] -mt-10 mb-9 font-display text-[40px] font-bold text-grey-6">Page Not Found</h2>
      <div className="mb-9 text-lg">Oops we can't seem to find the page you're looking for.</div>
      <Button appearance="reverse" size="lg">
        <Link to={PATH_HUB_HOME}>Back to home</Link>
      </Button>
    </div>
  );
};

export default PageNotFound;
